import {Box} from 'src/design/atoms/Box';
import React from 'react';
import type {IFormDocumentUploadFile} from '../FormFileDropzone/FormFileUploadV2';
import {useFileUtilities} from '../FormFileDropzone/hooks/useFileUtilities';
import {FormViewLabel} from '../FormViewLabel';
import {FileListView} from './FileListView';

export interface FormViewFileListRowProps {
  label: string;
  value: any;
  overrideIsImageCheck?: boolean;
}
export const FormViewFileListRow: React.FC<FormViewFileListRowProps> = ({
  label,
  value,
  overrideIsImageCheck,
}) => {
  const {safeFileArrayParse} = useFileUtilities();
  const files: IFormDocumentUploadFile[] = safeFileArrayParse(value).map(
    (file: IFormDocumentUploadFile) => ({
      ...file,
      name: file.file?.name ?? file.name,
    })
  );

  return (
    <Box mb="md">
      <FormViewLabel>{label}</FormViewLabel>
      <FileListView files={files} renderAsImage={overrideIsImageCheck} />
    </Box>
  );
};
